module.exports = {
  cacheDuration: 604800, // Time in seconds to save element caché
  checkPeriod: 1200, // Time in seconds to verify caché expiration and delete caché
};
